// ── AmountCell ────────────────────────────────────────────────────────────────

import { formatCurrency } from "@/application/money/types";

interface AmountCellProps {
  cents: number | null | undefined;
  currency: string | null | undefined;
}

export function AmountCell({ cents, currency }: AmountCellProps) {
  if (cents == null) {
    return <span className="text-subtle-foreground">—</span>;
  }

  const missingCurrency = currency == null;
  const formatted = formatCurrency(cents, currency);

  return (
    <span className="text-foreground font-medium">
      {formatted}
      {missingCurrency && (
        <span
          className="text-subtle-foreground ml-1 text-xs"
          title="Currency unknown"
        >
          ?
        </span>
      )}
    </span>
  );
}
